import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue';
import store from '@/store';
import ModalImportSearch from '../../search/ModalImportSearch.vue';
import ModalImportList from '../../list/ModalImportList.vue';
import { Item } from '@/components/Layers/modal/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalImportTabsDesigns',
  emits: ["design-selected"],
  setup(__props, { emit }: { emit: ({
    (event: 'design-selected'): void;
}), expose: any, slots: any, attrs: any }) {



const perPage = 5;
const isLoading = ref(true);
const currentPage = ref(1);
const searchText = ref('');

const designs = computed(() => store.state.storeLayersModal!.designs);
const totalDesigns = computed(() => store.state.storeLayersModal!.totalDesigns);

const items = computed(() => {
    return designs.value.map((design) => ({
        thumb: design.images[0],
        name: design.title,
        id: design.id
    }));
});

watch(currentPage, () => {
    fetchDesigns();
});

onMounted(async () => {
    await fetchDesigns();
});

const updateSearchText = async (value: string) => {
    searchText.value = value;
    await fetchDesigns();
};

const fetchDesigns = async () => {
    try {
        isLoading.value = true;
        await store.dispatch('storeLayersModal/getDesigns', {
            from: (currentPage.value - 1) * perPage,
            count: perPage,
            search: searchText.value,
            byAdmin: false
        });
    } finally {
        isLoading.value = false;
    }
};

const itemSelected = async (item: Item) => {
    try {
        isLoading.value = true;
        const design = designs.value.find((design) => design.id === item.id);
        if (design) {
            await store.dispatch('storeLayersModal/getDesign', design.id);
            store.dispatch('storeLayersModal/setSelectedItem', item);
            emit('design-selected');
        }
    } finally {
        isLoading.value = false;
    }
};

return { __sfc: true,emit, perPage, isLoading, currentPage, searchText, designs, totalDesigns, items, updateSearchText, fetchDesigns, itemSelected, ModalImportSearch, ModalImportList }
}

})